import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { SettingResult } from 'src/app/core/settings/settings.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'value-cell',
  template: `
    <span [ngClass]="{'value-cell': clickable}">{{settingResult | settingValue}}
      <span class="value-cell__thumbtack" *ngIf="entityId === settingResult.authoritativeEntityId"></span>
    </span>
  `,
  styleUrls: ['./value-cell.component.scss']
})
export class ValueCellComponent implements ICellRendererAngularComp {
  settingResult: SettingResult;
  clickable: boolean = false;
  entityId: string;

  constructor(private readonly activatedRoute: ActivatedRoute) { }

  agInit(params: any): void {
    this.refresh(params);
  }

  refresh(params: any): boolean {
    this.entityId = this.activatedRoute.snapshot.paramMap.get('selectedEntityId');
    this.settingResult = params.value;
    this.clickable = params.getIsClickable();
    return true;
  }
}
